import React from 'react';
import { SvgIconProps } from '@material-ui/core';

export const ArrowDownIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <svg {...props} viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.5" d="M1 1.25L6.5 6.75L12 1.25" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};
